import { render, staticRenderFns } from "./StaticViewComponent.vue?vue&type=template&id=49ecda38&scoped=true"
import script from "./StaticViewComponent.vue?vue&type=script&lang=js"
export * from "./StaticViewComponent.vue?vue&type=script&lang=js"
import style0 from "./StaticViewComponent.vue?vue&type=style&index=0&id=49ecda38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ecda38",
  null
  
)

export default component.exports